/**
 * Review Drawer Controller (Little Gusto style slide-in review panel)
 */
document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.getElementById('ReviewDrawer');
  const backdrop = document.getElementById('ReviewDrawerBackdrop');
  if (!drawer || !backdrop) return;

  const closeBtn = drawer.querySelector('[data-review-drawer-close]');
  const writeBtn = drawer.querySelector('[data-review-write-toggle]');
  const formWrap = drawer.querySelector('[data-review-form-wrap]');
  const reviewForm = drawer.querySelector('#ReviewDrawerForm');

  const openDrawer = (e) => {
    if (e) e.preventDefault();
    drawer.classList.add('is-active');
    backdrop.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  };

  const closeDrawer = () => {
    drawer.classList.remove('is-active');
    backdrop.classList.remove('is-active');
    document.body.style.overflow = '';
  };

  // Attach click listeners to all open review drawer triggers
  const attachTriggers = () => {
    const triggers = document.querySelectorAll(
      '.js-open-review-drawer, [data-open-review-drawer], .product__rating, .jdgm-prev-badge, .spr-badge'
    );
    triggers.forEach((trigger) => {
      // Avoid attaching multiple times
      if (!trigger.dataset.drawerBound) {
        trigger.dataset.drawerBound = 'true';
        trigger.style.cursor = 'pointer';
        trigger.addEventListener('click', openDrawer);
      }
    });
  };

  attachTriggers();
  // Re-check for dynamically loaded app widgets (like Judge.me or Loox)
  setTimeout(attachTriggers, 1500);
  setTimeout(attachTriggers, 3000);

  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (backdrop) backdrop.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('is-active')) {
      closeDrawer();
    }
  });

  // Toggle write review form
  if (writeBtn && formWrap) {
    writeBtn.addEventListener('click', () => {
      formWrap.classList.toggle('is-open');
      if (formWrap.classList.contains('is-open')) {
        writeBtn.textContent = 'Formu Kapat';
        formWrap.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      } else {
        writeBtn.textContent = 'Değerlendirme Yaz';
      }
    });
  }

  // Star selector in form
  const formStars = drawer.querySelectorAll('[data-star-rating]');
  const ratingInput = drawer.querySelector('#ReviewRatingInput');
  if (formStars.length > 0 && ratingInput) {
    formStars.forEach((star) => {
      star.addEventListener('click', () => {
        const rating = parseInt(star.dataset.starRating, 10);
        ratingInput.value = rating;
        formStars.forEach((s) => {
          const sRating = parseInt(s.dataset.starRating, 10);
          s.textContent = sRating <= rating ? '★' : '☆';
        });
      });
    });
  }

  // Review Form Submit Handler
  if (reviewForm) {
    reviewForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const submitBtn = reviewForm.querySelector('button[type="submit"]');
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Gönderiliyor...';
      }

      setTimeout(() => {
        if (formWrap) {
          formWrap.innerHTML = `
            <div style="text-align: center; padding: 20px 10px;">
              <span style="font-size: 32px;">✓</span>
              <h4 style="margin: 10px 0 6px 0; font-size: 16px;">Teşekkür Ederiz!</h4>
              <p style="margin: 0; font-size: 13px; color: #666;">Değerlendirmeniz onaylandıktan sonra yayınlanacaktır.</p>
            </div>
          `;
        }
      }, 700);
    });
  }
});
